<template>
	<div class="jointproduct">
		<HNB single-title="跨界联名产品"></HNB>
		<div class="jointtotal">
			<div class="jointbox" v-for="(item,i) in producttotal">
				<div class="joint-title">{{item.title}}</div>
				<div class="joint-write">{{item.write}}</div>
				<div class="jointproduct-box">
					<div class="joint-product" v-for="e in item.product">
						<div class="joint-product-img">
							<img class="amplification_1_1" :src="e.img" />
						</div>
						<div class="joint-product-info">{{e.info}}</div>
					</div>
				</div>
			</div>
		</div>
		<BS :BsTitle="bsTitle"></BS>
	</div>
</template>


<script>
	import HNB from '../components/HeaderNavigationBar.vue'
	import BS from '../components/bottomShow.vue'
	export default {
		name: 'jointproduct',
		data() {
			return {
				bsTitle: [ '跨界联名产品'],
				producttotal: [{
					title: '乐范 × 熊本熊',
					write: '每天按摩15分钟，元气能量嘭起来。萌、呆、潮、贱，把熊本熊魔力按摩贴带回家撒欢，让它治愈你的疲惫吧!',
					product: [{
							img: this.GLOBAL.imgHost + '/images/jointproduct/bear1.png',
							info: '（酷炫魔力按摩贴 熊本熊黑）'
						},
						{
							img: this.GLOBAL.imgHost + '/images/jointproduct/bear2.png',
							info: '（酷炫魔力按摩贴 萌力白）'
						},
					]
				}, 
				{
					title: '乐范 × 迪士尼',
					write: '我们想给大家带来亲切熟悉又新鲜有趣的体验，忙碌的生活中既能愉快的放松身体，也能激发儿时的动画情怀，于是迪士尼联名款魔力按摩贴应运而生。',
					product: [{
							img: this.GLOBAL.imgHost + '/images/jointproduct/Disney1.png',
							info: '（米奇出没 妙趣横生）'
						},
						{
							img: this.GLOBAL.imgHost + '/images/jointproduct/Disney2.png',
							info: '（时尚米妮 童心童趣）'
						},
					]
				}, 
				{
					title: '乐范 × 得到',
					write: '得到，用互联网思维去读书，提供碎片化学习方式。而乐范，为高压生活环境下的年轻人提供碎片化的轻松方式，让按摩变得简单。乐范 × 得到，推出三款按摩产品，在得到知识的同时获得身心全放松，让健康生活如影随行。',
					product: [{
							img: this.GLOBAL.imgHost + '/images/jointproduct/dedao1.png',
							info: '（得到定制炫酷版魔力贴 几何系列）'
						},
						{
							img: this.GLOBAL.imgHost + '/images/jointproduct/dedao2.png',
							info: '（得到定制温情版魔力贴 双生鹰系列）'
						},
						{
							img: this.GLOBAL.imgHost + '/images/jointproduct/dedao3.png',
							info: '（石墨烯加热眼罩）'
						},
					]
				}, 
				{
					title: '乐范 × 吴晓波频道',
					write: '把吴晓波的书名《把生命浪费在美好的事物上》印在乐范石墨烯加热眼罩上，温润冷眼世情。',
					product: [{
							img: this.GLOBAL.imgHost + '/images/jointproduct/wuxiaobo1.png',
							info: '（特别定制版）'
						},
						{
							img: this.GLOBAL.imgHost + '/images/jointproduct/wuxiaobo2.png',
							info: '（特别定制版）'
						},
						{
							img: this.GLOBAL.imgHost + '/images/jointproduct/wuxiaobo3.png',
							info: '（特别定制版）'
						},
					]
				},
				 {
				 	title: '乐范 × 日行千里',
				 	write: '动感气囊，对小腿进行有节奏的按摩，促进肌肉酸胀，让奔波忙碌的双腿得到轻松释放。',
				 	product: [{
				 			img: this.GLOBAL.imgHost + '/images/jointproduct/xingzou.png',
				 			info: '（脚部气压按摩器 日行千里系列）'
				 		}
				 	]
				 },]
			}
		},
		components: {
			HNB,
			BS
		},
		methods: {

		}
	}
</script>

<style>
	.jointtotal {
		padding-top: 5rem;
		width: 64rem;
		margin: 0 auto 100px;
	}

	.jointtotal .jointbox {
		width: 100%;
		padding-top: 12%;
		/* border: #000000 1px solid; */
	}

	.jointtotal .jointbox .joint-title {
		width: 25rem;
		height: 4rem;
		font-family: Alibaba-PuHuiTi-M;
		/* border: 0.0625rem saddlebrown solid; */
		font-size: 1.8rem;
		 
		font-weight: 550;
		color: rgba(29, 29, 29, 1);
		line-height: 4rem;
		margin: 0 auto;
	}

	.jointtotal .jointbox .joint-write {
		width: 32rem;
		height: 4rem;
		/* border: 0.0625rem saddlebrown solid; */
		margin: 0 auto;
		font-size: 0.8rem;
		 
		font-weight: 400;
		color: rgba(29, 29, 29, 1);
		/* line-height:59px; */
	}
	.jointtotal .jointbox .jointproduct-box{
		display: flex;
		justify-content: center;
		padding-top: 3%;
		
	}
	.jointtotal .jointbox .joint-product {
		width: 13rem;
		height: 13rem;
		background: rgba(244,244,244,1);
		/* box-shadow: 0px 25px 50px 0px rgba(41, 44, 51, 0.1); */
		margin-left:1.875rem ;
		margin-right:1.875rem ;
	}
	.jointtotal .jointbox .joint-product:hover{
		/* background:rgba(255,255,255,1); */
	}
	.jointtotal .jointbox .joint-product .joint-product-img {
		width: 70%;
		margin: 0 auto;
		padding-top: 10%;
	}

	.jointtotal .jointbox .joint-product .joint-product-img img {
		width: 100%;
	}

	.jointtotal .jointbox .joint-product .joint-product-info {
		
		font-size:0.8rem;
		font-family:Alibaba PuHuiTi;
		font-weight:400;
		color:rgba(95,95,95,1);
		/* line-height:56px; */
	}
</style>
